/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_Metric_Help_DescInputs */

const en_ui_settings_metric_help_desc = /** @type {(inputs: Ui_Settings_Metric_Help_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display info icons next to metrics`)
};

const de_ui_settings_metric_help_desc = /** @type {(inputs: Ui_Settings_Metric_Help_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info-Symbole neben Metriken einblenden`)
};

/**
* | output |
* | --- |
* | "Display info icons next to metrics" |
*
* @param {Ui_Settings_Metric_Help_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_metric_help_desc = /** @type {((inputs?: Ui_Settings_Metric_Help_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_Metric_Help_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_metric_help_desc(inputs)
	return de_ui_settings_metric_help_desc(inputs)
});